import React from 'react'

const headshot = require("../assets/headshot.jpg")

const Headshot = () => {
    return (
        <div className="headshot">
            <div className="cropper">
                <img src={headshot} alt="delesslin_headshot" className="profile-pic" />
            </div>
        </div>
    )
}

export default Headshot
